<template>
    <form>
        <div class="form-group">
            <label for="title">Título <span class="text-danger">*</span></label>
            <input
                type="text"
                class="form-control"
                id="title"
                v-model="banner.title"
                placeholder="Titulo"
            />
        </div>
        <div class="form-group">
            <label for="summary"
                >Resumen <span class="text-danger">*</span></label
            >
            <ckeditor
                :editor="editor"
                v-model="banner.summary"
                :config="editorConfig"
            ></ckeditor>
        </div>
        <div class="row row-cols-1 row-cols-md-2">
            <span>
                <div class="form-group col">
                    <label for="button_text">Titulo botón</label>
                    <input
                        type="text"
                        class="form-control"
                        id="button_text"
                        v-model="banner.button_text"
                        disabled
                    />
                </div>
            </span>
            <span>
                <div class="form-group col">
                    <label for="button_link">Link botón (Call to Action)</label>
                    <input
                        type="text"
                        class="form-control"
                        id="button_link"
                        v-model="banner.button_link"
                        disabled
                    />
                </div>
            </span>
        </div>
        <div class="row row-cols-1 row-cols-md-2">
            <span>
                <div class="form-group col">
                    <label for="background_color">Color de fondo</label>
                    <multiselect
                        v-model="banner.background_color"
                        placeholder="Seleccione un color"
                        label="name"
                        track-by="id"
                        :options="arrayColors"
                        :disabled="true"
                    ></multiselect>
                </div>
            </span>
            <span>
                <div class="form-group col">
                    <label for="button_color">Color botón</label>
                    <multiselect
                        v-model="banner.button_color"
                        placeholder="Seleccione un color"
                        label="name"
                        track-by="id"
                        :options="arrayColors"
                        :disabled="true"
                    ></multiselect>
                </div>
            </span>
        </div>

        <div class="row row-cols-1">
            <span>
                <div class="form-group col">
                    <label for=""
                        >Imagen banner <span class="text-danger">*</span></label
                    >
                    <vue-dropzone
                        ref="bannerPhoto"
                        id="bannerPhoto"
                        :options="dropzoneOptions"
                        @vdropzone-complete="afterUploadComplete"
                    ></vue-dropzone>
                    <small id="bannerPhotoHelp" class="form-text text-muted"
                        >Solo se admite imagenes en formato .webp</small
                    >
                </div>
            </span>
        </div>
        <div class="row row-cols-1 row-cols-md-2">
            <span>
                <div class="form-group col">
                    <label for="text_image_alt"
                        >Descripción imagen (alt)
                        <span class="text-danger">*</span></label
                    >
                    <input
                        type="text"
                        class="form-control"
                        id="text_image_alt"
                        v-model="banner.text_image_alt"
                    />
                </div>
            </span>
            <span>
                <div class="form-group col">
                    <label for="image_url"
                        >Url imagen <span class="text-danger">*</span
                        ><a
                            v-if="banner.image_url"
                            :href="banner.image_url"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            (Ver imagen)</a
                        ></label
                    >
                    <input
                        type="text"
                        class="form-control"
                        v-model="banner.image_url"
                        readonly
                    />
                </div>
            </span>
        </div>

        <button type="button" @click="createBanner()" class="btn btn-primary">
            Crear Banner
        </button>
    </form>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import helpers from "../../mixins/index";

export default {
    name: "SectionPrehomeCreateBannerComponent",
    mixins: [helpers],
    components: {
        vueDropzone: vue2Dropzone,
    },
    data() {
        return {
            banner: {
                title: null,
                summary: null,
                button_text: null,
                button_link: null,
                background_color: null,
                button_color: null,
                image: null,
                image_url: null,
                text_image_alt: null,
                type: "prehome",
            },
            arrayColors: [],
            editor: ClassicEditor,
            editorConfig: {
                toolbar: ["bold", "italic", "link"],
            },
            dropzoneOptions: {
                url: this.getUploadImageUrl(),
                maxFilesize: 2048,
                paramName: "qqfile",
                disablePreviews: true,
                addRemoveLinks: true,
                acceptedFiles: ".webp",
            },
        };
    },
    methods: {
        createBanner() {
            let me = this;
            me.loading();
            const authUserId = document.querySelector(
                'meta[name="x-user"]'
            ).content;

            axios
                .post(`/api/banners?type=prehome&key=${authUserId}`, me.banner)
                .then(function () {
                    me.closeLoading();
                    me.showActionSuccess('Banner creado');
                })
                .catch(function () {
                    me.showSwalError(
                        "No fue posible procesar su solicitud, intente mas tarde."
                    );
                });
        },

        getListColors() {
            const me = this;
            axios
                .get("/api/sections/colors")
                .then(function (response) {
                    me.arrayColors = response.data;
                })
                .catch(function () {
                    me.showSwalError(
                        "No fue posible procesar su solicitud, intente mas tarde."
                    );
                });
        },

        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },

        afterUploadComplete: async function (response) {
            if (response.status === "success") {
                const data = JSON.parse(response.xhr.response);
                this.banner.image = data.path;
                this.banner.image_url = data.url;
                this.showActionSuccess("Carga de imagen exitosa!");
            } else {
                const e = document.querySelector(".dz-error-message");
                e.remove();
                this.showActionError("Carga de imagen fallo!");
            }
        },
    },
    mounted() {
        this.getListColors();
    },
};
</script>
